module.exports = __webpack_public_path__ + "img/bad-active.9252f2ce.svg";